export enum AutomationActionError {
  EmptyNote = 'emptyNote',
  EmptyTags = 'emptyTags',
  EmptyTask = 'emptyTask',
  EmptyAssignTo = 'emptyAssignTo',
  EmptyFollowers = 'emptyFollowers',
  EmptyTeamMembers = 'emptyTeamMembers',
  EmptyEvaluationForm = 'emptyEvaluationForm',
  EmptyEvaluationMembers = 'emptyEvaluationMembers',
  EmptyJobStatus = 'emptyJobStatus',
  EmptyJobBoards = 'emptyJobBoards',
  UserRoleError = 'userRoleError',
  EmptyEmailSubject = 'emptyEmailSubject',
  EmptyEmailBodyHtml = 'emptyEmailBodyHtml',
}
